// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"71588d35","455":"9cd550a6","977":"52fc8c2e"}[chunkId] + ".chunk.js";
};